import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button } from "semantic-ui-react";
import { bindActionCreators } from "redux";

import { abilitiesSelector } from "../../../../selectors/user";
import { getParentPageHref } from "../../../../utils/routeHelpers";
import LayoutOverlay from "../../../../components/LayoutOverlay";
import styles from "./AddPallet.module.css";
import Loader from "../../../../components/Loader";
import { getPalletById } from "../../../../actions/Pallets/pallets";
import AddPalletForm from "./AddPalletForm";

class AddPallet extends Component {
  state = {
    isFetching: false,
    pallet: null,
  };

  constructor(props) {
    super(props);
    this.palletForm = React.createRef();
  }

  async componentWillMount() {
    const { match } = this.props;
    const { id } = match.params;
    if (id) {
      this.getPalletById(id);
    } else {
      this.setState({
        isFetching: false,
      });
    }
  }

  getPalletById = (id) => {
    const {
      actions: { getPalletById },
    } = this.props;
    this.setState({
      isFetching: true,
    });

    getPalletById(id)
      .then((pallet) => {
        const extendedPallet = {
          ...pallet,
          areas: pallet.areas.map((area) => area.area.id),
        };

        if (pallet.variety) extendedPallet.crop = pallet.variety.crop;
        if (pallet.areas.length)
          extendedPallet.farmIDs = [
            ...new Set(pallet.areas.map(({ area }) => area.farm.id)),
          ].filter((id) => !!id);

        this.setState({
          isFetching: false,
          pallet: extendedPallet,
        });
      })
      .catch((error) => {
        if (error.response.status === 404) {
          this.props.navigate("/404");
        }
        this.setState({
          isFetching: false,
        });
      });
  };

  doSubmitForm = () => {
    if (this.palletForm.current) {
      this.palletForm.current.submit();
    }
  };

  render() {
    const {
      route,
      Can,
      match: {
        params: { id },
      },
      navigate,
    } = this.props;
    const { isFetching, pallet } = this.state;

    return (
      <LayoutOverlay
        closeLink={getParentPageHref(route)}
        route={{
          ...route,
          name: id ? route.name.replace("Add", "Edit") : route.name,
        }}
        childrenOnly
        footer={
          <div className={styles.buttonsFooter}>
            <Can I="add" a="packed_boxes">
              <Button primary size="large" onClick={this.doSubmitForm}>
                Save
              </Button>
            </Can>
          </div>
        }
      >
        {isFetching ? (
          <Loader />
        ) : (
          <AddPalletForm
            navigate={navigate}
            route={route}
            initialValues={pallet}
            formRef={this.palletForm}
          />
        )}
      </LayoutOverlay>
    );
  }
}

AddPallet.propTypes = {
  route: PropTypes.object.isRequired,
  pallet: PropTypes.object,
  match: PropTypes.object,
  actions: PropTypes.object,
  Can: PropTypes.func,
};

AddPallet.defaultProps = {
  route: { name: "{%name%}" },
};

const mapStateToProps = (state) => {
  return {
    Can: abilitiesSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getPalletById,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPallet);
